import DistrictSidebar from "../../components/DistrictSidebar";
import SettingsLayout from "../../components/settings/SettingsLayout";
import SettingsSections from "../../components/settings/SettingsSections";

export default function SettingsPage() {
  const role = (() => {
    try {
      return JSON.parse(localStorage.getItem("user"))?.role;
    } catch {
      return undefined;
    }
  })();

  return (
    <SettingsLayout Sidebar={DistrictSidebar}>
      <SettingsSections role={role} />
    </SettingsLayout>
  );
}
